import { render, staticRenderFns } from "./BDXMatchPendingManagerListHeader.vue?vue&type=template&id=379d16bc&scoped=true"
import script from "./BDXMatchPendingManagerListHeader.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManagerListHeader.vue?vue&type=script&lang=js"
import style0 from "./BDXMatchPendingManagerListHeader.vue?vue&type=style&index=0&id=379d16bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d16bc",
  null
  
)

export default component.exports